/**
 * Screen zone boundaries for input handling.
 * Single source of truth for flipper/tilt zone split.
 */
export const INPUT_ZONES = {
  /** Top 65% of screen is tilt zone, bottom 35% is flipper zone */
  tiltZoneBottom: 0.65,
  flipperZoneTop: 0.65,
} as const;
